<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">알림톡 발송</span>
            <span class="txt">센터 내 전자계약 서류 알림톡 발송내역과 템플릿을 관리할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/noti/basic')">기본정보</button>
                <button @click="onClickRouter('/madmin/noti/talk')">알림톡 발송내역</button>
                <button @click="onClickRouter('/madmin/noti/template')">템플릿 관리</button>
                <button class="on">센터별 발송현황</button>
            </div>

            <table class="com-table left" style="margin-top: 30px">
                <colgroup>
                    <col style="width: 60px" />
                    <col style="width: 500px" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>기간</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                                <div class="com-dash"><span class="dash">~</span></div>
                                <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                                <select-form
                                    style="margin-left: 10px"
                                    :select-data="['오늘', '어제', '이번달', '지날달', '3개월', '6개월', '12개월']"
                                    :select-value="[
                                        'today',
                                        'yesterday',
                                        'thisMonth',
                                        'prevMonth',
                                        'threeMonth',
                                        'sixMonth',
                                        'year',
                                    ]"
                                    :selected-value="period"
                                    @update:set="(val) => periodc(val)"
                                ></select-form>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>센터명</th>
                        <td>
                            <div class="com-calendar-wrap">
                                <div class="input-box">
                                    <input v-model="searchStr" placeholder="" type="text" />
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="bottom-btn" style="margin-top: 20px">
                <button class="com-btn" @click="onSearchList">검색</button>
                <button class="com-btn border-button general-button big" @click="onConditionInit">조건 초기화</button>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>발송 내역</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count">
                            총
                            <span class="blue">{{ pagingInfo.totalItems }}</span>
                            건
                        </span>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 170px" />
                        <col style="width: 170px" />
                        <col style="width: 150px" />
                        <col style="width: 150px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="sortColumn == 'c_senter_name' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                    @click="onClickCenterName"
                                >
                                    센터 명
                                </button>
                            </th>
                            <th>
                                <button
                                    :class="sortColumn == 'k_sign_count' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                    @click="onClickCountK"
                                >
                                    카카오톡 서명 발송 건
                                </button>
                            </th>
                            <th>
                                <button
                                    :class="sortColumn == 'd_sign_count' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                    @click="onClickCountD"
                                >
                                    직접 서명 발송 건
                                </button>
                            </th>
                            <th>
                              <button
                                  :class="sortColumn == 'cancel_count' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                  @click="onClickCountCancel"
                              >
                                  취소 건
                              </button>
                            </th>
                            <th>
                              <button
                                  :class="sortColumn == 'complete_count' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                  @click="onClickCountComplete"
                              >
                                  완료 건
                              </button>
                            </th>
                            <th>총 발송 금액</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, i) in sendList" :key="i">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.nts_id"
                                        v-model="selected"
                                        :value="i"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.nts_id"></label>
                                </div>
                            </td>
                            <td>
                                {{t.c_center_name}}
                            </td>
                            <td>
                                {{t.k_sign_count}}
                            </td>
                            <td>
                                {{t.d_sign_count}}
                            </td>
                            <td>
                                {{t.cancel_count}}
                            </td>
                            <td>
                              {{t.complete_count}}
                            </td>
                            <td>
                              {{getNumberFormat(t.all_count * 300)}}원
                            </td>
                        </tr>
                        <tr v-if="sendList.length === 0">
                            <td colspan="100">발송된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="pagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="pagingInfo.page"
                    :per-page="pagingInfo.limit"
                    :total-rows="pagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import XLSX from 'xlsx';
import {numberFormat} from '@/assets/js/excelCommon';

export default {
    name: 'notiTalk',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
    },
    props: {},
    computed: {},
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            isLoading: false,
            pagingInfo: { ...pagingInfo },
            sendList: [],
            sortColumn: 'c_center_nm',
            sortType: 'DESC',

            selectedAll: false,
            selected: [],

            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            startDate: this.initStartDate(),
            endDate: this.initEndDate(),
            period: 'thisMonth', // 등록일 조회
            searchStr: '',
        };
    },
    methods: {
        getNumberFormat(num) {
          return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 초기화
        async init() {
            this.isLoading = true;

            this.onSearchList();

            this.isLoading = false;
        },

        // 한 페지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.sendList) {
                    this.selected.push(parseInt(i));
                }
            }
        },
        // 검색 종료일
        initEndDate() {
            const endDate = moment().endOf('month').format('YYYY-MM-DD');
            return endDate;
        },

        // 검색 시작일
        initStartDate() {
            const startDate = moment().startOf('month').format('YYYY-MM-DD');
            return startDate;
        },

        periodc(newValue) {
            this.period = newValue;
            if (newValue === 'thisMonth') {
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'today') {
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'lastWeek') {
                this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'threeMonth') {
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'sixMonth') {
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'year') {
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            }
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },

        onClickCountK() {
            this.sortColumn = 'k_sign_count';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }

            this.onSearchList();
        },

        onClickCountD() {
            this.sortColumn = 'd_sign_count';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }

            this.onSearchList();
        },

        onClickCountCancel() {
          this.sortColumn = 'cancel_count';
          if (this.sortType === '' || this.sortType === 'DESC') {
            this.sortType = 'ASC';
          } else {
            this.sortType = 'DESC';
          }

          this.onSearchList();
        },

        onClickCountComplete() {
          this.sortColumn = 'complete_count';
          if (this.sortType === '' || this.sortType === 'DESC') {
            this.sortType = 'ASC';
          } else {
            this.sortType = 'DESC';
          }

          this.onSearchList();
        },

        onClickCenterName() {
            this.sortColumn = 'sender_name';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }

            this.onSearchList();
        },

        getDocumentList() {
            // 스웨거: Lesson Manage Paging 목록 조회
            let params = {
                startDate: moment(this.startDate).format('YYYYMMDD'),
                endDate: moment(this.endDate).format('YYYYMMDD'),
                searchStr: this.searchStr,
                sortColumn: this.sortColumn,
                sortType: this.sortType,
                ...this.pagingInfo,
            };

            return api.get(`/admin/api/center/noti/talk/status`, {
                params,
            });
        },

        getDocumentListNoPage() {
          // 스웨거: Lesson Manage Paging 목록 조회
          let params = {
            startDate: moment(this.startDate).format('YYYYMMDD'),
            endDate: moment(this.endDate).format('YYYYMMDD'),
            searchStr: this.searchStr,
            sortColumn: this.sortColumn,
            sortType: this.sortType,
          };

          return api.get(`/admin/api/center/noti/talk/status_all`, {
            params,
          });
        },

        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        onSearch() {
            this.pagingInfo.page = 1;

            this.onSearchList();
        },

        async onSearchList() {
            try {
                this.isLoading = true;

                const { data } = await this.getDocumentList();
                this.setPageParams(data);
                this.sendList = data.items;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        // 검색어 입력 처리
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
        },

        // 페지 이동
        onClickRouter(path, menu = '', eventNum = '') {
            this.$router.push({
                path: `${path}`,
            });
        },

        onConditionInit() {
            this.startDate = this.initStartDate();
            this.endDate = this.initEndDate();
            this.period = 'thisMonth';
            this.searchStr = '';
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.getDocumentListNoPage();

            const excelDownloadArray = [];
            data.forEach((item) => {
                const temp = {};
                temp['센터명'] = item.c_center_name;
                temp['카카오톡 서명 발송건'] = item.k_sign_count;
                temp['직접 서명 발송건'] = item.d_sign_count;
                temp['취소 건'] = item.cancel_count;
                temp['완료 건'] = item.complete_count;
                temp['총 발송금액'] = numberFormat(item.all_count * 300) + '원';

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [{ wch: 30 }, { wch: 60 }, { wch: 60 }, { wch: 30 }, { wch: 30 }, { wch: 40 }];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '센터별발송현황');
            XLSX.writeFile(wb, `센터별발송현황_${new Date().toLocaleDateString().toString()}.xlsx`);
        },
    },
};
</script>
<style lang="scss"></style>
